export const LogLevel = Object.freeze({
    i: 1,
    e: 2,
    w: 3,
    a: 4,
    d: 5,
  });
  
  class Logger {
    static i(level, msg) {
      if (level === LogLevel.i) {
        Logger.log(msg);
      }
    }
  
    static e(level, msg) {
      if (level > LogLevel.i) {
        Logger.log(msg);
      }
    }
  
    static w(level, msg) {
      if (level > LogLevel.e) {
        Logger.log(msg);
      }
    }
  
    static a(level, msg) {
      if (level > LogLevel.w) {
        Logger.log(msg);
      }
    }
  
    static d(level, msg) {
      if (level > LogLevel.a) {
        Logger.log(msg);
      }
    }
  
    static log(msg) {
      console.log(`${msg}`);
    }
  
    static printStackTrace(error) {
      console.error(error);
      console.trace();
    }

    static messageStackTrace(message, error) {
      console.error(message,error);
      console.trace();
    }
  }

  export default Logger;
  